import Categories from './components/categories';
import EventModel from '../../../utils/tracking/models';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import Link from 'react-router-dom/Link';
import MainMenu from '../nav_main_menu/nav_main_menu';
import mainMenuContext from '../nav_main_menu/nav_main_menu_data';
import matchMediaDesktop from '../../../utils/client_util';
import Notice from './components/notice';
import outerHeight from '../../../utils/outerheight_util';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Social from './components/social';
import throttle from 'lodash/throttle';
import { UserConsumer } from '../context/userContext';

class Masthead extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menu: false,
      active: true,
      isMobile: null,
      hideTitle: false,
      expandUser: false,
      cantClose: true
    };

    // NOTIFICATION KILLSWITCH
    this.showNotice = !isEmpty(props.homepageTopPromo);

    this.lastScroll = 0;
    this.toggleMenu = this.toggleMenu.bind(this);
    this.closeActiveMenu = this.closeActiveMenu.bind(this);
    this.navTimeout = undefined;
    this.mastcontainer = React.createRef();
    this.handleTopNavAdPositioning = this.handleTopNavAdPositioning.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.resize = this.resize.bind(this);
    this.mouseOverUser = this.mouseOverUser.bind(this);
    this.mouseLeavingUser = this.mouseLeavingUser.bind(this);
    this.closeUser = this.closeUser.bind(this);
  }

  componentDidMount() {
    if (typeof window.queryly !== 'undefined') {
      window.queryly.init(
        'c99eafd2993b450c',
        document.querySelectorAll('.masthead, section,footer'),
        { uiversion: 1 }
      );
    }

    this.handleNavScroll = throttle(this.handleNavScroll.bind(this), 100);
    window.addEventListener('scroll', this.handleNavScroll);

    window.addEventListener('resize', this.resize);
    this.resize();

    if (this.props.hasTopNavAd && matchMediaDesktop()) {
      window.addEventListener('scroll', this.handleTopNavAdPositioning);
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleNavScroll);
    window.removeEventListener('resize', this.handleResize);
    if (this.props.hasTopNavAd && matchMediaDesktop()) {
      window.removeEventListener('scroll', this.handleTopNavAdPositioning);
    }
  }

  trackLoginClick() {
    const loginClickEvent = new EventModel(
      `login nav link`,
      `login link`,
      `click`,
      `nav-login`,
      `1 | 5`
    );

    loginClickEvent.triggerTrackingEvent(
      'login-nav',
      loginClickEvent.getTrackingObject()
    );
  }

  handleNavScroll() {
    const currentScroll = window.pageYOffset;
    const latestScroll = this.lastScroll;

    if (currentScroll > latestScroll && latestScroll > 1 && this.state.active) {
      this.setState({ active: false });
    } else if (
      (currentScroll < latestScroll || latestScroll < 1) &&
      !this.state.active
    ) {
      this.setState({ active: true });
    }
    this.lastScroll = currentScroll;

    if (this.state.expandUser) {
      this.mouseLeavingUser();
    }
  }

  handleTopNavAdPositioning() {
    if (!this.topNavAd) {
      this.topNavAd = document.querySelector('.homepage-page__ff-ad-container');
    }

    if (this.topNavAd) {
      const height = outerHeight(this.topNavAd);
      // debugger;
      if (window.scrollY >= height) {
        this.mastcontainer.style = 'position: fixed;';
      } else {
        this.mastcontainer.style = 'position: relative;';
      }
    }
  }

  handleResize() {
    window.removeEventListener('scroll', this.handleTopNavAdPositioning);
    if (this.props.hasTopNavAd && matchMediaDesktop()) {
      window.addEventListener('scroll', this.handleTopNavAdPositioning);
      this.handleTopNavAdPositioning();
    }
  }

  toggleMenu() {
    this.setState({ menu: !this.state.menu });
  }

  closeActiveMenu() {
    this.navTimeout = setTimeout(() => {
      this.setState({ active: false });
    }, 2000);
  }

  resize() {
    const isMobile = window.innerWidth <= 913;
    if (isMobile !== this.state.isMobile) {
      this.setState({ isMobile });
    }
  }

  mouseOverUser() {
    let { hideTitle } = this.state;
    if (this.state.isMobile) {
      hideTitle = true;
    }

    setTimeout(() => {
      this.setState({
        cantClose: false
      });
    }, 500);

    this.setState({
      expandUser: true,
      hideTitle
    });
  }

  mouseLeavingUser() {
    let { hideTitle } = this.state;
    if (this.state.isMobile || hideTitle === true) {
      hideTitle = false;
    }

    this.setState({
      expandUser: false,
      hideTitle
    });
  }

  closeUser() {
    if (!this.state.cantClose && this.state.isMobile && this.state.expandUser) {
      this.setState({
        hideTitle: false,
        expandUser: false,
        cantClose: true
      });
    } else {
      this.mouseOverUser();
    }
  }

  render() {
    const {
      topics,
      channels,
      trackClick,
      config,
      activeCategory,
      hasTopNavAd,
      displayOptions
    } = this.props;
    const { menu, active } = this.state;
    const site = get(this.props.config, 'site', '');
    const social = get(mainMenuContext, `social.${site}`, []);

    if (!displayOptions.show) return false;

    if (displayOptions.logoOnly) {
      return (
        <React.Fragment>
          <div
            ref={mastcontainer => {
              this.mastcontainer = mastcontainer;
            }}
            className={
              hasTopNavAd ? 'masthead masthead--top-nav-ad' : 'masthead'
            }
          >
            <header className="masthead__header">
              <Link to="/" className="masthead__title">
                <h2>Fast Company</h2>
              </Link>
            </header>
          </div>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        {this.showNotice && (
          <Notice homepageTopPromo={this.props.homepageTopPromo} />
        )}
        <div
          ref={mastcontainer => {
            this.mastcontainer = mastcontainer;
          }}
          className={hasTopNavAd ? 'masthead masthead--top-nav-ad' : 'masthead'}
          onMouseEnter={() => {
            clearTimeout(this.navTimeout);
            this.setState({ active: true });
          }}
          onMouseLeave={this.closeActiveMenu}
        >
          <header className="masthead__header">
            {this.state.hideTitle ? (
              ''
            ) : (
              <Link to="/" className="masthead__title">
                <h2>Fast Company</h2>
              </Link>
            )}
            <button
              onClick={this.toggleMenu}
              className="masthead__menu"
              aria-label="dropdown menu"
            />
            <div className="masthead__interactive">
              <Social data={social} trackClick={trackClick} />
              <UserConsumer>
                {({
                  isLoggedIn,
                  showScreen,
                  logoutUser,
                  isUserValid,
                  isActiveSubscriber
                }) => {
                  const isSubscribed = isUserValid && isActiveSubscriber;
                  let emag = '';
                  if (isSubscribed) {
                    emag = (
                      <li className="masthead__user-item">
                        <a
                          target="_blank"
                          className="masthead__user-button"
                          rel="noopener noreferrer"
                          href="https://digital.fastcompany.com/account/VipLogin/F0C157ED-4341-41CE-8F27-DBB558CB6D25"
                        >
                          <p>Digital Magazine</p>
                        </a>
                      </li>
                    );
                  }
                  if (isLoggedIn) {
                    return (
                      <div
                        className={`masthead__user ${
                          this.state.expandUser ? 'masthead__user--hover' : ''
                        }`}
                        onMouseEnter={this.mouseOverUser}
                        onMouseLeave={this.mouseLeavingUser}
                      >
                        <span
                          className={`masthead__user-label masthead__user-logo ${
                            isSubscribed ? 'subscriber' : ''
                          }`}
                          onClick={this.closeUser}
                        >
                          <img
                            alt="user account icon"
                            src="https://images.fastcompany.net/image/upload/v1612289973/fcweb/account-icon_hqgzbi.svg"
                          />
                        </span>
                        <ul
                          className={`masthead__user-list ${
                            isSubscribed ? 'subscriber' : ''
                          }`}
                        >
                          <li className="masthead__user-item">
                            <a
                              className="masthead__user-button"
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={e => {
                                e.preventDefault();
                                logoutUser();
                                this.mouseLeavingUser();
                              }}
                            >
                              <p className="logoutLink">Logout</p>
                            </a>
                          </li>
                          {emag}
                          <li className="masthead__user-item">
                            <a
                              className="masthead__user-button"
                              rel="noopener noreferrer"
                              href="/myaccount"
                            >
                              <p>Account</p>
                            </a>
                          </li>
                        </ul>
                      </div>
                    );
                  }
                  return (
                    <div
                      className="masthead__user-login"
                      onClick={e => {
                        e.preventDefault();
                        showScreen({
                          screen: 'login',
                          mode: 'modal'
                        });

                        /**
                         * NOTE: this could live in context `showScreen` function
                         * via a switch statement if the logic is generic enough.
                         */
                        this.trackLoginClick();
                      }}
                    >
                      <span className="masthead__user-label">Login</span>
                    </div>
                  );
                }}
              </UserConsumer>
              <button className="masthead__search" aria-label="site search">
                <label htmlFor="queryly_toggle">
                  <i className="icon-search-glass" />
                </label>
              </button>
            </div>
          </header>
          <Categories
            topics={topics}
            channels={channels}
            active={active}
            activeCategory={activeCategory}
            trackClick={trackClick}
          />
          <MainMenu
            closeMenu={this.toggleMenu}
            mainMenuVisible={menu}
            config={config}
            topics={topics}
            {...mainMenuContext}
          />
        </div>
      </React.Fragment>
    );
  }
}

Masthead.propTypes = {
  config: PropTypes.shape({}).isRequired,
  topics: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  channels: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  trackClick: PropTypes.func,
  activeCategory: PropTypes.string.isRequired,
  hasTopNavAd: PropTypes.bool.isRequired,
  homepageTopPromo: PropTypes.shape({}),
  displayOptions: PropTypes.shape({
    show: PropTypes.bool,
    logoOnly: PropTypes.bool
  })
};

Masthead.defaultProps = {
  trackClick: () => {},
  homepageTopPromo: {},
  displayOptions: {
    show: true,
    logoOnly: false
  }
};

export default Masthead;
